import { Routes, Route } from "react-router-dom";
import "./i18n";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import StatePage from "./pages/StatePage";
import VoterListPage from "./pages/VoterListPage";
import VoterSearch from "./pages/VoterSearch";
import ViewNomination from "./pages/ViewNomination";
import MembershipModel from "./pages/MembershipModel";
import MembershipCount from "./pages/MembershipCount";
import PerformersList from "./pages/PerformersList";
import RODetails from "./pages/ROList";
import StateSchedulePage from "./pages/StateSchedulePage";
import ROSchedule from "./pages/ROSchedule";
import StateMapping from "./pages/StateMapping";
import GetResult from "./pages/GetResult";
import HowToBecomeMember from "./pages/HowToBecomeMember";
import FAQ from "./pages/FAQ";
import { LoaderProvider } from "./context/LoaderContext";
import SearchResults from "./pages/SearchResults";
import ReservedDistrictsPage from "./pages/ReservedDistricts";
import InternalGetResult from "./pages/InternalGetResult"; // New internal page for testing results before public release
import StateGuard from "./components/StateGuard";
import CurrentMemberCount from "./pages/CurrentMemberCount";

function App() {
  return (
    <LoaderProvider>
      <Header />
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/state/:stateId" element={<StatePage />} />

          <Route
            path="/reject-list"
            element={
              <StateGuard>
                <VoterListPage />
              </StateGuard>
            }
          />

          <Route
            path="/voter-list"
            element={
              <StateGuard>
                <VoterListPage />
              </StateGuard>
            }
          />

          <Route
            path="/on-hold-list"
            element={
              <StateGuard>
                <VoterListPage />
              </StateGuard>
            }
          />

          <Route
            path="/voter-search"
            element={
              <StateGuard>
                <VoterSearch />
              </StateGuard>
            }
          />

          <Route
            path="/view-nomination"
            element={
              <StateGuard>
                <ViewNomination />
              </StateGuard>
            }
          />

          <Route
            path="/membership-model"
            element={
              <StateGuard>
                <MembershipModel />
              </StateGuard>
            }
          />

          <Route
            path="/membership-count"
            element={
              <StateGuard>
                <MembershipCount />
              </StateGuard>
            }
          />
          <Route
            path="/current-member-count"
            element={
              <StateGuard>
                <CurrentMemberCount />
              </StateGuard>
            }
          />

          <Route
            path="/performers-list"
            element={
              <StateGuard>
                <PerformersList />
              </StateGuard>
            }
          />

          <Route
            path="/ro-details"
            element={
              <StateGuard>
                <RODetails />
              </StateGuard>
            }
          />

          <Route
            path="/state-schedule"
            element={
              <StateGuard>
                <StateSchedulePage />
              </StateGuard>
            }
          />

          <Route
            path="/ro-schedule"
            element={
              <StateGuard>
                <ROSchedule />
              </StateGuard>
            }
          />

          <Route
            path="/state-mapping"
            element={
              <StateGuard>
                <StateMapping />
              </StateGuard>
            }
          />

          <Route
            path="/get-result"
            element={
              <StateGuard>
                <GetResult />
              </StateGuard>
            }
          />

<Route
  path="/internal-get-result/:stateId/:ballotId?"
  element={<InternalGetResult />}
/>

          <Route
            path="/get-result/:stateId/:ballotId?"
            element={
              <StateGuard>
                <GetResult />
              </StateGuard>
            }
          />

          <Route path="/how-to-become-member" element={<HowToBecomeMember />} />
          <Route path="/faq" element={<FAQ />} />

          <Route
            path="/search"
            element={
              <StateGuard>
                <SearchResults />
              </StateGuard>
            }
          />

          <Route
            path="/reserved-districts"
            element={
              <StateGuard>
                <ReservedDistrictsPage />
              </StateGuard>
            }
          />
        </Routes>
      </main>
      <Footer />
    </LoaderProvider>
  );
}

export default App;